import React from 'react';
import { useTranslation } from 'react-i18next';
import ResumeInfoCard from '../../../../../components/ResumeInfoCard';
import { DocumentationFolderIcon, FolderPerson } from '../../../../../components/buttons/IconButtons';
import RowResumeText from '../../../../../components/RowResumeText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';

/**
 * @Author: Susana García Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const SummaryDetailsCard = ({ user, item }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('details')}
            titleIcon={<DocumentationFolderIcon width={24} height={24} />}
            icon={<FolderPerson className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='grid-container-resume-data mb-2'>
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                       title={t('acronym')} value={user?.acronym || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                         title={t('company_name')}
                            value={user?.contractorCompanyName || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                       title={t('address')} value={user?.address || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                      title={t('service_type')} value={item?.name || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                       title={t('description')} value={user?.description || EMPTY_VALUES.DEFAULT}
                    />
                </div>
            }
        />
    );
};

export default SummaryDetailsCard;
